module.exports = __webpack_public_path__ + "img/subtitle-2.8b5e57e7.svg";